import { Injectable } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter, map, startWith } from "rxjs/operators";
import { Observable, BehaviorSubject, merge } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class BreadcrumbServiceService {
  private dynamicBreadcrumbs$ = new BehaviorSubject<any[] | null>(null);

  constructor(private router: Router, private route: ActivatedRoute) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.dynamicBreadcrumbs$.next(null));
  }

  updateBreadcrumbs(breadcrumbs: any[]) {
    this.dynamicBreadcrumbs$.next(breadcrumbs);
  }

  getBreadcrumbs(): Observable<any[]> {
    const routeBreadcrumbs$ = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      startWith(this.router),
      map(() => {
        let route = this.route.root;
        let breadcrumbs: any[] = [];
        while (route.children.length) {
          route = route.children[0];
          if (route?.snapshot?.data["breadcrumb"]) {
            breadcrumbs = [
              ...breadcrumbs,
              ...route.snapshot.data["breadcrumb"],
            ];
          }
        }
        return breadcrumbs;
      })
    );

    return merge(
      routeBreadcrumbs$,
      this.dynamicBreadcrumbs$.pipe(filter((b) => b !== null))
    ) as Observable<any[]>;
  }
}
